
  import {Component, Prop, Vue} from 'vue-property-decorator';

  @Component({})
  export default class HomeBasicInfo extends Vue {
    @Prop({default: () => true}) private show!: boolean;

    private currentShow = this.show;
    private baseUrl = Vue.prototype.$appsettings.serverUrl + '/';

    private get faceIcon() {
      let faceIcon = this.$store.getters.faceIcon;
      if (faceIcon) {
        return this.baseUrl + faceIcon;
      }
      return '';
    }

    private get contactNumber() {
      let contactNumber = this.$store.getters.contactNumber;
      return contactNumber;
    }

    private get address() {
      let address = this.$store.getters.address;
      return address;
    }

    private get link() {
      let link = this.$store.getters.link;
      return link;
    }

    private get businessHours() {
      let businessHours = this.$store.getters.businessHours;
      return businessHours;
    }

    private handleLink() {
      if (this.link) {
        window.location.href = this.link;
      }
    }

    private handlerClose() {
      this.$emit('close', false);
    }
  };
